import type { Origen } from './DeDondeSalio';

/**
 * De qué está hecho el hilo de «Probá tu bot».
 *
 * Extraído de `ProbarElBot.tsx` al agregarle el aviso de «ya probó»
 * (GKTIBO-123), que lo empujaba por encima de las 300 líneas (D4).
 */

export interface Simulada {
  herramienta: string;
  enVivo: string;
}

export interface Turno {
  id: number;
  de: 'bot' | 'dueno';
  texto: string;
  origen?: Origen;
  /** Lo que el dueño preguntó. Sólo en los turnos del bot, para corregir. */
  pregunta?: string;
  simuladas?: Simulada[];
  /** El bot perdió el hilo entre este turno y el anterior. */
  sesionNueva?: boolean;
}

/**
 * El id de sesión se arma una vez por montaje.
 *
 * Toda la conversación viaja con el mismo: es lo que permite que el bot
 * recuerde los turnos anteriores. Y **no es un teléfono ni un id de persona**,
 * así que esta charla no puede confundirse con una real.
 */
export function nuevaSesion(): string {
  return `prueba-${Math.random().toString(36).slice(2)}-${Date.now()}`;
}
